import React from "react";
import {
  MdHome,
  MdBarChart,
  MdPerson,
  MdLock,
  MdOutlineAccountBalanceWallet,
  MdCalendarMonth,
  MdBookOnline,
  MdList,
  MdPeople,
  MdAddShoppingCart,
  MdSettings,
  MdReceipt,
  MdPersonAdd,
  MdHistory,
  MdInventory,
  MdEventAvailable,
  MdRateReview,
  MdAttachMoney,
  MdNotificationsActive,
  MdOutlineDashboard,
  MdStore,
  MdNotifications,
  MdBrowseGallery,
  MdMoney,
  MdStar,
  MdPhoto,
  MdPhotoAlbum,
  MdImage,
  MdOutlineGroupAdd,
  MdAssessment,
  MdComment,
} from "react-icons/md";
import { BsBank, BsCash, BsCalendarCheck, BsBoxSeam, BsGraphUp, BsBriefcase } from "react-icons/bs";
import { IoPeople, IoTimeOutline, IoExitOutline } from "react-icons/io5";
import { GiHypodermicTest } from "react-icons/gi";
import { FcGallery, FcRatings } from "react-icons/fc";
import { GoGraph } from "react-icons/go";

// --- VIEW IMPORTLARI ---
import Login from "views/auth/Login";
import FastLogin from "views/auth/FastLogin";
import Register from "views/auth/Register";

// Admin System
import AdminDashboard from "views/admin_sys/dashboard/admin_dashboard";
import AdminCalendar from "views/admin_sys/calendar/admin_calendar";
import AdminServices from "views/admin_sys/services/admin_services";
import AdminTransactionAnalytics from "views/admin_sys/transaction_analytics/admin_trasaction_analytics";
import AdminAppointmentList from "views/admin_sys/appointmen_list/admin_appointment_list";
import Admin_customerList from "views/admin_sys/CustomerList/admin_customerList";
import AdminStaffList from "views/admin_sys/staff_crud/admin_staff_list"
import AdminStaffServiceAssignmetns from "views/admin_sys/staff_service_assignments/staff_service_assignments"
import AdminScheduleManager from "views/admin_sys/ScheduleManager/admin_schedule_manager"
import Admin_Staff_Availablity from "views/admin_sys/Staff_Availablity/Staff_Availablity"
import Admin_Staff_Ratings from "views/admin_sys/StaffRatings/admin_staff_ratings"
import Admin_Staff_Analytics from "views/admin_sys/Staff_Analytics/admin_staff_analytics"
import AdminBankAccountManagement from "views/admin_sys/BankAccountManagement/admin_bank_account_management"
import AdminStaffSalaryPrimList from "views/admin_sys/StaffPrimSistemiListesi/admin_staff_prim_sistemi_listesi"
import AdminStaffSalaryPrimManagement from "views/admin_sys/SalaryPrimManagement/admin_salary_prim_management"
import AdminTransactionHistory from "views/admin_sys/TransactionHistory/admin_transaction_history"
import AdminStockList from "views/admin_sys/StockList/admin_stock_list"
import AdminStockHistory from "views/admin_sys/StockSalesHistory/admin_stock_history"
import AdminStockAnalytics from "views/admin_sys/StockAnalytics/admin_stock_analytics"
import AdminGalleryManagement from "views/admin_sys/GalleryManagement/admin_gallery_management"
import AdminCalendarMobil from "views/admin_sys/CalendarMobil/admin_calendar_mobil"

// Vault (Kasa)
import VaultDashboard from "views/vault/dashboard/vault_dashboard";
import VaultAdisyon from "views/vault/adisyon/vault_adisyon";
import VaultCRM from "views/vault/crm/vault_crm";
import VaultTransactionHistory from "views/vault/TransactionHistory/vault_transaction_history"
import VaultFollowUp from "views/vault/FollowUp/vault_follow_up"
// Common (Ortak)
import Common_Reminders from "views/common/reminders/common_reminders";
import CommonProfile from "views/common/Profile/Profile"
import CommonCreateNewCustomer from "views/common/CreateNewCustomer/common_create_new_customer"

// Customer ROTALARI
import Customer_dashboard from "views/customer/dashboard/customer_dashboard";
import Customer_booking from "views/customer/booking/customer_booking";
import Customer_Appointment_History from "views/customer/AppointmentHistory/customer_appointment_history"
import Customer_Product_List from "views/customer/ProductList/customer_product_list"
import Customer_Notifications from "views/customer/Notifications/customer_notifications.jsx"
import Customer_Gallery from "views/customer/Gallery/customer_gallery"
import Customer_PriceList from "views/customer/PriceList/customer_price_list"
import Customer_Reviews from "views/customer/Reviews/customer_reviews"
import Customer_Comments from "views/customer/Comments/customer_comments"
//STAFF
import StaffDashboard from "views/staff/dashboard/staff_dashboard"
import StaffCalendar from "views/staff/calendar/staff_calendar"
import StaffAppointmentHistory from  "views/staff/AppointmentHistory/staff_appointment_history"
import StaffAppointmentRequests from "views/staff/AppointmentRequest/staff_appointment_request"
import StaffTransactionList from "views/staff/TransactionList/staff_transaction_list"
import StaffReviews from "views/staff/Reviews/staff_reviews"
import StaffUpcomingAppointments from "views/staff/UpcomingAppointments/staff_upcoming_appointments"

// Henüz eklenmeyen komponentler için geçici placeholder
const Placeholder = ({ name }) => <div className="p-10 text-gray-500 font-bold text-center w-full"> {name} Sayfası Henüz Hazırlanmadı </div>;

const routes = [
  // ==========================================
  // --- TEKİL ROTALAR (Dropdown Olmayanlar)
  // ==========================================
  {
    name: "Ana Menü",
    layout: "/admin",
    path: "dashboard",
    icon: <MdHome className="h-6 w-6" />,
    component: <AdminDashboard />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 1 },
  },
  {
    name: "Kasa Paneli",
    layout: "/vault",
    path: "dashboard",
    icon: <BsBriefcase className="h-6 w-6" />,
    component: <VaultDashboard />,
    roles: ["vault", "admin"],
    sidebarVisible: true,
    order: { vault: 1, admin: 2 },
  },
  {
    name: "Adisyon (Satış)",
    layout: "/vault",
    path: "adisyon",
    icon: <BsCash className="h-6 w-6" />,
    component: <VaultAdisyon />,
    roles: ["admin", "vault", "staff"],
    sidebarVisible: true,
    order: { admin: 4, vault: 3, staff: 4 },
  },
  {
    name: "Hatırlatıcılar",
    layout: "/admin",
    path: "reminders",
    icon: <IoTimeOutline className="h-6 w-6" />,
    component: <Common_Reminders />,
    roles: ["admin", "staff"],
    sidebarVisible: true,
    order: { admin: 5, staff: 5 },
  },
  {
    name: "Hizmet Yönetimi",
    layout: "/admin",
    path: "services",
    icon: <MdSettings className="h-6 w-6" />,
    component: <AdminServices />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 6 },
  },
  {
    name: "Müşteri Kartları",
    layout: "/vault",
    path: "crm",
    icon: <IoPeople className="h-6 w-6" />,
    component: <VaultCRM />,
    roles: ["admin", "vault", "staff"],
    sidebarVisible: true,
    order: { admin: 7, vault: 4, staff: 9 },
  },

  {
    name: "Hatırlatma & Takip",
    layout: "/vault",
    path: "follow-ups",
    icon: <MdNotificationsActive className="h-6 w-6" />,
    component: <VaultFollowUp />,
    roles: ["admin", "vault"],
    sidebarVisible: true,
    order: { admin: 8, vault: 5 }, // Sıralamaları araya girecek şekilde ayarladım
  },

  {
    name: "Müşteri Listesi",
    layout: "/admin",
    path: "customer",
    icon: <MdPeople className="h-6 w-6" />,
    component: <Admin_customerList />,
    roles: ["admin", "vault"],
    sidebarVisible: true,
    order: { admin: 8, vault: 5 },
  },
  {
    name: "Yeni Müşteri Kayıt",
    layout: "/vault",
    path: "newcustomer",
    icon: <MdPersonAdd className="h-6 w-6" />,
    component: <CommonCreateNewCustomer />,
    roles: ["vault", "staff", "admin"],
    sidebarVisible: true,
    order: { vault: 6, staff: 10, admin: 99 },
  },
  {
    name: "Randevu Listesi",
    layout: "/admin",
    path: "appointment/list",
    icon: <MdList className="h-6 w-6" />,
    component: <AdminAppointmentList />,
    roles: ["admin", "vault"],
    sidebarVisible: true,
    order: { admin: 9, vault: 7 },
  },
  {
    name: "Finans Geçmişi",
    layout: "/vault",
    path: "transaction",
    icon: <MdMoney className="h-6 w-6" />,
    component: <VaultTransactionHistory />,
    roles: ["vault"],
    sidebarVisible: true,
    order: { vault: 8 },
  },
  {
    name: "Galeri İşlemleri",
    layout: "/admin",
    path: "gallery",
    icon: <MdImage className="h-6 w-6" />,
    component: <AdminGalleryManagement />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 14 },
  },

  // ==========================================
  // --- TAKVİM GRUBU (DROPDOWN)
  // ==========================================
  {
    name: "Randevu Takvimi",
    layout: "/admin",
    path: "calendar",
    icon: <MdCalendarMonth className="h-5 w-5" />,
    menu: "Takvim İşlemleri",
    menuIcon: <MdCalendarMonth className="h-6 w-6" />,
    component: <AdminCalendar />,
    roles: ["admin", "vault"],
    sidebarVisible: true,
    order: { admin: 3, vault: 2 },
  },
  {
    name: "Mobil Görünüm",
    layout: "/admin",
    path: "calendar-mobile",
    icon: <MdBookOnline className="h-5 w-5" />,
    menu: "Takvim İşlemleri",
    component: <AdminCalendarMobil />,
    roles: ["admin", "vault"],
    sidebarVisible: true,
    order: { admin: 3, vault: 2 },
  },

  // ==========================================
  // --- PERSONEL YÖNETİMİ GRUBU (DROPDOWN)
  // ==========================================
  {
    name: "Personel Listesi",
    layout: "/admin",
    path: "staff",
    icon: <MdPeople className="h-5 w-5" />,
    menu: "Personel Yönetimi",
    menuIcon: <MdOutlineGroupAdd className="h-6 w-6" />,
    component: <AdminStaffList />,
    roles: ["admin", "vault"],
    sidebarVisible: true,
    order: { admin: 10, vault: 10 },
  },
  {
    name: "Hizmet Atamaları",
    layout: "/admin",
    path: "assignments",
    icon: <GiHypodermicTest className="h-5 w-5" />,
    menu: "Personel Yönetimi",
    component: <AdminStaffServiceAssignmetns />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 10 },
  },
  {
    name: "Çalışma Planı",
    layout: "/admin",
    path: "schedule",
    icon: <IoTimeOutline className="h-5 w-5" />,
    menu: "Personel Yönetimi",
    component: <AdminScheduleManager />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 10 },
  },
  {
    name: "Müsaitlik Yönetimi",
    layout: "/admin",
    path: "staff/appointments",
    icon: <MdEventAvailable className="h-5 w-5" />,
    menu: "Personel Yönetimi",
    component: <Admin_Staff_Availablity />,
    roles: ["admin", "vault"],
    sidebarVisible: true,
    order: { admin: 10, vault: 10 },
  },
  {
    name: "Değerlendirmeler",
    layout: "/admin",
    path: "staff/ratings",
    icon: <FcRatings className="h-5 w-5" />,
    menu: "Personel Yönetimi",
    component: <Admin_Staff_Ratings />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 10 },
  },
  {
    name: "Personel Analizi",
    layout: "/admin",
    path: "appointment/analytics",
    icon: <GoGraph className="h-5 w-5" />,
    menu: "Personel Yönetimi",
    component: <Admin_Staff_Analytics />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 10 },
  },

  // ==========================================
  // --- FİNANS YÖNETİMİ GRUBU (DROPDOWN)
  // ==========================================
  {
    name: "Finans Geçmişi",
    layout: "/admin",
    path: "transaction/list",
    icon: <MdHistory className="h-5 w-5" />,
    menu: "Finans Yönetimi",
    component: <AdminTransactionHistory />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 11 },
  },
  {
    name: "Finans Analizi",
    layout: "/admin",
    path: "transaction/analytics",
    icon: <BsGraphUp className="h-5 w-5" />,
    menu: "Finans Yönetimi",
    component: <AdminTransactionAnalytics />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 11 },
  },
  {
    name: "Banka Hesapları",
    layout: "/admin",
    path: "bankaccounts",
    icon: <MdOutlineAccountBalanceWallet className="h-5 w-5" />,
    menu: "Finans Yönetimi",
    component: <AdminBankAccountManagement />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 11 },
  },
  {
    name: "Maaş-Prim Raporları",
    layout: "/admin",
    path: "dailyreports",
    icon: <MdReceipt className="h-5 w-5" />,
    menu: "Finans Yönetimi",
    component: <AdminStaffSalaryPrimList />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 11 },
  },
  {
    name: "Maaş-Prim Ayarları",
    layout: "/admin",
    path: "salary",
    icon: <MdSettings className="h-5 w-5" />,
    menu: "Finans Yönetimi",
    component: <AdminStaffSalaryPrimManagement />,
    roles: ["admin"],
    sidebarVisible: true,
    order: { admin: 11 },
  },

  // ==========================================
  // --- STOK YÖNETİMİ GRUBU (DROPDOWN)
  // ==========================================
  {
    name: "Stok Yönetimi",
    layout: "/admin",
    path: "stock/list",
    icon: <MdInventory className="h-5 w-5" />,
    menu: "Stok ve Satış",
    menuIcon: <BsBoxSeam className="h-6 w-6" />,
    component: <AdminStockList />,
    roles: ["admin", "vault"],
    sidebarVisible: true,
    order: { admin: 12, vault: 9 },
  },
  {
    name: "Satış Geçmişi",
    layout: "/admin",
    path: "stock/history",
    icon: <MdHistory className="h-5 w-5" />,
    menu: "Stok ve Satış",
    component: <AdminStockHistory />,
    roles: ["admin", "vault"],
    sidebarVisible: true,
    order: { admin: 12, vault: 9 },
  },
  {
    name: "Satış Analizi",
    layout: "/admin",
    path: "stock/analytics",
    icon: <MdAssessment className="h-5 w-5" />,
    menu: "Stok ve Satış",
    component: <AdminStockAnalytics />,
    roles: ["admin", "vault"],
    sidebarVisible: true,
    order: { admin: 12, vault: 9 },
  },

  // ==========================================
  // --- PERSONEL (STAFF PANEL) ROTALARI
  // ==========================================
  {
    name: "Ana Panelim",
    layout: "/staff",
    path: "dashboard",
    icon: <MdHome className="h-6 w-6" />,
    component: <StaffDashboard />,
    roles: ["staff"],
    sidebarVisible: true,
    order: { staff: 1 },
  },
  {
    name: "Randevu Takvimi",
    layout: "/staff",
    path: "calendar",
    icon: <MdList className="h-6 w-6" />,
    component: <StaffCalendar />,
    roles: ["staff"],
    sidebarVisible: true,
    order: { staff: 2 },
  },
  {
    name: "Randevu Talepleri",
    layout: "/staff",
    path: "requests",
    icon: <MdBookOnline className="h-6 w-6" />,
    component: <StaffAppointmentRequests />,
    roles: ["staff"],
    sidebarVisible: true,
    order: { staff: 6 },
  },
  {
    name: "Yaklaşan Randevular",
    layout: "/staff",
    path: "upcoming",
    icon: <MdList className="h-6 w-6" />,
    component: <StaffUpcomingAppointments />,
    roles: ["staff"],
    sidebarVisible: true,
    order: { staff: 7 },
  },
  {
    name: "Randevu Geçmişi",
    layout: "/staff",
    path: "history",
    icon: <MdHistory className="h-6 w-6" />,
    component: <StaffAppointmentHistory />,
    roles: ["staff"],
    sidebarVisible: true,
    order: { staff: 8 },
  },
  {
    name: "Finans",
    layout: "/staff",
    path: "finance",
    icon: <BsBank className="h-6 w-6" />,
    component: <StaffTransactionList />,
    roles: ["staff"],
    sidebarVisible: true,
    order: { staff: 11 },
  },
  {
    name: "Değerlendirmelerim",
    layout: "/staff",
    path: "reviews",
    icon: <MdStar className="h-6 w-6" />,
    component: <StaffReviews />,
    roles: ["staff"],
    sidebarVisible: true,
    order: { staff: 12 },
  },

  // ==========================================
  // --- MÜŞTERİ (CUSTOMER) ROTALARI
  // ==========================================
  {
    name: "Ana Menü",
    layout: "/customer",
    path: "dashboard",
    icon: <MdHome className="h-6 w-6" />,
    component: <Customer_dashboard />,
    roles: ["customer"],
    sidebarVisible: true,
    order: { customer: 1 },
  },
  {
    name: "Randevu Al",
    layout: "/customer",
    path: "booking",
    icon: <MdBookOnline className="h-6 w-6" />,
    component: <Customer_booking />,
    roles: ["customer"],
    sidebarVisible: true,
    order: { customer: 2 },
  },
  {
    name: "Randevularım",
    layout: "/customer",
    path: "appointments",
    icon: <MdHistory className="h-6 w-6" />,
    component: <Customer_Appointment_History />,
    roles: ["customer"],
    sidebarVisible: true,
    order: { customer: 3 },
  },
  {
    name: "Ürünler",
    layout: "/customer",
    path: "store",
    icon: <MdStore className="h-6 w-6" />,
    component: <Customer_Product_List />,
    roles: ["customer"],
    sidebarVisible: true,
    order: { customer: 4 },
  },
  {
    name: "Bildirimler",
    layout: "/customer",
    path: "notifications",
    icon: <MdNotifications className="h-6 w-6" />,
    component: <Customer_Notifications />,
    roles: ["customer"],
    sidebarVisible: true,
    order: { customer: 5 },
  },
  {
    name: "Galeri",
    layout: "/customer",
    path: "gallery",
    icon: <MdPhoto className="h-6 w-6" />,
    component: <Customer_Gallery />,
    roles: ["customer"],
    sidebarVisible: true,
    order: { customer: 6 },
  },
  {
    name: "Fiyat Listesi",
    layout: "/customer",
    path: "price-list",
    icon: <MdMoney className="h-6 w-6" />,
    component: <Customer_PriceList />,
    roles: ["customer"],
    sidebarVisible: true,
    order: { customer: 7 },
  },
  {
    name: "Değerlendirmelerim",
    layout: "/customer",
    path: "reviews",
    icon: <MdStar className="h-6 w-6" />,
    component: <Customer_Reviews />,
    roles: ["customer"],
    sidebarVisible: true,
    order: { customer: 8 },
  },
  {
    name: "Yorumlar",
    layout: "/customer",
    path: "comments",
    icon: <MdComment className="h-6 w-6" />,
    component: <Customer_Comments />,
    roles: ["customer"],
    sidebarVisible: true,
    order: { customer: 8 },
  },

  // ==========================================
  // --- GİZLİ (SIDEBAR'DA GÖRÜNMEYEN) ORTAK ROTALAR
  // ==========================================
  {
    name: "Profil Ayarları",
    layout: "/admin",
    path: "profile",
    component: <CommonProfile />,
    roles: ["admin"],
    sidebarVisible: false,
  },
  {
    name: "Profil Ayarları",
    layout: "/staff",
    path: "profile",
    component: <CommonProfile />,
    roles: ["staff"],
    sidebarVisible: false,
  },
  {
    name: "Profil Ayarları",
    layout: "/vault",
    path: "profile",
    component: <CommonProfile />,
    roles: ["vault"],
    sidebarVisible: false,
  },
  {
    name: "Profil Ayarları",
    layout: "/customer",
    path: "profile",
    component: <CommonProfile />,
    roles: ["customer"],
    sidebarVisible: false,
  },

  // ==========================================
  // --- AUTH ROTALARI (GİZLİ)
  // ==========================================
  {
    name: "Giriş Yap",
    layout: "/auth",
    path: "sign-in",
    component: <Login />,
    sidebarVisible: false,
  },
  {
    name: "Hızlı Giriş",
    layout: "/auth",
    path: "fast-login",
    component: <FastLogin />,
    sidebarVisible: false,
  },
];

export default routes;